// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    DEALERS_OVERVIEW_GET_DATA_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    dealergetDataResult,
} from 'Redux/actions';

// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* getDealer({ payload }) {
    try {
        let QUERY_DEALER = `
            query getDealer ($id: Int!) {
                result: getDealer (id: $id) {
                    id
                    name
                    masterCompanyId
                    masterCompany {
                        id
                        dealerId
                        name
                        crmId
                    }
                    email
                    username
                    createdBy
                    createdOn
                    updatedBy
                    updatedOn
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY_DEALER,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result) {
            yield put(dealergetDataResult({ data: data.result }));
        } else {
            yield put(dealergetDataResult({ data: null }));
        }

    } catch (exc) {
        yield put(dealergetDataResult({ error: true }));
    }
}


function* watchMethods() {
    yield takeEvery(DEALERS_OVERVIEW_GET_DATA_REQUEST, getDealer);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}